import * as React from 'react';
import { SocialBarWrapper, SocialButtonsWrapper, MailToAnchor, MailAnchorWrapper } from './SocialBarStyles';
import { CopyrightLayout } from './Layouts/Copyright/CopyrightLayout';
import { SocialButtonLayout, Props as SocialButtonLayoutProps } from './Layouts/SocialButton/SocialButtonLayout';
import { SocialBarSchema } from '../../../../Schema/SocialBarSchema';
import { actionTaken } from '../../../../ReduxApp/app/user-sessions/duck/operations';
import { AvailableActions } from '../../../../ReduxApp/app/user-sessions/duck/actionTypes';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';

export type Props = {};

const iconsSchema = SocialBarSchema;

export const SocialBarLayout = (props: Props) => {
	const location = useLocation();
	const dispatch = useDispatch();
	const render = () => {
		const iconsJSX = iconsSchema.map((iconSchema: any, index) => {
			const onClick = () => {
				// dispatch(actionTaken(AvailableActions.BUTTON_PRESSED, 'Footer -> Social Bar -> ' + index, location.pathname));
				window.open(iconSchema.link.replace('%url%', iconSchema.link), '_blank');
			};
			const outgoingProps: SocialButtonLayoutProps = {
				icon: iconSchema.icon,
				onClick,
			};
			const returnValue = <SocialButtonLayout key={'socialbutton' + index} {...outgoingProps} />;
			return returnValue;
		});

		const returnValue = (
			<SocialBarWrapper>
				<SocialButtonsWrapper>{iconsJSX}</SocialButtonsWrapper>
				{/*<MailAnchorWrapper>*/}
				{/*	<MailToAnchor href="mailto:support@kidiup.com">Contact us at support@kidiup.com</MailToAnchor>*/}
				{/*</MailAnchorWrapper>*/}
				<CopyrightLayout />
			</SocialBarWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
